import React, { ReactNode } from 'react';
import Alert, { AlertColor } from '@mui/material/Alert';
import { AlertType } from '../../utilities/types';

type CustomAlertProps = {
  children: ReactNode | string;
  type: AlertType;
  variant?: 'outlined' | 'filled';
  color?: AlertColor;
  onClose?: () => void;
  action?: ReactNode;
};

const CustomAlert: React.FC<CustomAlertProps> = ({
  children,
  type = 'info',
  variant = 'filled',
  color,
  onClose,
  action,
}) => (
  <Alert severity={type} variant={variant} onClose={onClose} action={action} color={color}>
    {children}
  </Alert>
);

export default CustomAlert;
